import { Component, OnInit, ViewChild } from '@angular/core';
import { UsersService } from 'app/pages/users/users.service';
import { GridOptions } from 'ag-grid';
import { ProvidersBillingService } from '../providers-billing-service.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { ClaimButtonComponent } from 'app/pages/A2-utils/grid-components/claim-button/claim-button.component';
import { BatchClaimButtonComponent } from 'app/pages/A2-utils/grid-components/batch-claim-button/batch-claim-button.component';
import { _currencyFormat } from 'app/utils/trip2-query-builder/utils/helpers';

@Component({
  selector: 'app-processed-claims',
  templateUrl: './processed-claims.component.html',
  styleUrls: ['./processed-claims.component.scss']
})
export class ProcessedClaimsComponent implements OnInit {

  protected selectedProvider: any;
  protected providers = [];
  protected grid = <GridOptions> {};
  onFiltered: boolean;
  modalOpen = false;
  selectedBatchId: any;

  @ViewChild('batchDetailModal') private batchModal: T2CardComponent;

  constructor(
    private userService: UsersService,
    private service: ProvidersBillingService,
    private loading: T2LoadingService
  ) {
    this.grid.columnDefs = this.getColumns();
    this.grid.onFilterChanged = (params) => {
      this.onFiltered = params.api['filterManager'].advancedFilterPresent;
    };

    // TODO Cargar Grid Vacia
    this.grid.onGridReady = () => {
      this.grid.api.setRowData([]);
    };
   }

  ngOnInit() {
    this.getProviders();
  }

  onChangeProvider() {
    this.getBatchs();
  }

  /**
   * @name clearFilters
   * @description clear grid filters
   */
  clearFilters() {
    this.grid.api.setFilterModel(null);
    this.onFiltered = false;
  }

  /**
   * this get providers data from server
   */
  private getProviders() {
    this.userService.getProvidersForUserOrderBy().subscribe(
      data => {
        if (data.length === 1) {
          this.selectedProvider = data[0].companyid;
        }
        this.providers = data;
      }
    )
  }

  /**
   * this get batchs when user select a provider
   */
  private getBatchs() {
    this.loading.show();
    if (this.selectedProvider) {
      this.service.setCompanyId(this.selectedProvider);
      this.service.getBatchs(this.selectedProvider)
      .finally(() => {
        this.loading.hiden();
      })
      .subscribe(
        res => {
          this.grid.api.setRowData(res);
        }
      )
    }
  }

  /**
   * this execute when user make souble click in the grid
   * @param event batch selected
   */
  openBatch(event) {
    this.selectedBatchId = event.data.providerclaimid;
    this.batchModal.open();
  }

  /**
   * this execute when modal emit the events
   * @param event modal event
   */
  onModalEvents(event) {
    this.modalOpen = event.isOpen;

    if (!this.modalOpen) {
      this.selectedBatchId  = 0;
    }
  }

  /**
   * this format the amount cell
   */
  private amountCell = function(params) {
    return _currencyFormat(params.value ? params.value : 0);
  }

  private getColumns() {
    return [
      {
        headerName: 'Batch Id',
        field: 'providerclaimid',
        colId: 'batchid',
        width: 100,
        cellClass: ['text-a-center']
      },
      {
        headerName: 'Date Processed',
        field: 'datereceived',
        colId: 'dateprocessed',
        width: 200
      },
      {
        headerName: 'Trips',
        field: 'totalclaimtrip',
        colId: 'trips',
        cellClass: ['text-a-center'],
        width: 100
      },
      {
        headerName: 'Total Amount',
        field: 'totalamountclaimtrips',
        colId: 'amount',
        cellRenderer: this.amountCell,
        cellClass: ['text-a-right'],
        width: 150
      },
      {
        headerName: 'Status',
        field: 'batchclaimstatus.description',
        colId: 'status'
      },
      {
        headerName: 'Report',
        cellRendererFramework: BatchClaimButtonComponent,
        colId: 'report',
        width: 100
      }
    ];
  }

  onGridReady(event) {
    event.api.sizeColumnsToFit();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/providers-billing/processed-claims/processed-claims.component.ts